import RectangleButton from './rectangle-button';

export { RectangleButton };
